import React, { useState } from 'react';
import { ActivityTimeline } from './ActivityTimeline';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import clsx from 'clsx';

interface Props {
	date: string;
	data: any;
	openModal?: (value: any) => void;
	setScript?: (value: any) => void;
	checkedItemId?: number;
	setCheckedItemId?: (value: number) => void;
}

export const ActivityLogSection = (props: Props): React.ReactElement => {
	const { date, data, openModal, setScript, checkedItemId, setCheckedItemId } = props;
	const [isAreaCollapsed, setIsAreaCollapsed] = useState<boolean>(false);

	return (
		<>
			<div
				className="px-3 py-2 d-flex align-items-center cursor-pointer group-log-style"
				onClick={(): void => setIsAreaCollapsed(prev => !prev)}
			>
				<FontAwesomeIcon icon={faChevronDown} width={12} className={clsx('transition-rotate', isAreaCollapsed ? 'rotate-0' : 'rotate-minus-90')}/>
				<div className="fs-5 fw-bolder pe-10 mx-auto">
					{date}
				</div>
			</div>
			<div
				className={clsx('transition-height mb-5', !isAreaCollapsed ? 'height-0' : 'dropdown-box-shadow p-3')}
			>
				<ActivityTimeline
					activityList={data}
					openModal={openModal}
					setScript={setScript}
					checkedItemId={checkedItemId}
					setCheckedItemId={setCheckedItemId}
				/>
			</div>

		</>
	);
};
